import * as ngCore from '@angular/core'
import * as ngRouter from '@angular/router'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../../../../state'

/**
 * TODO: Js doc
 */
@ngCore.Component({
  // TODO: why?
  changeDetection: ngCore.ChangeDetectionStrategy.OnPush,
  imports: [ds.overlay.attached.Component, ngRouter.RouterLink],
  selector: 'atn-scenario-dropdown-overlay-section-scenario',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.routeBound.scenarios.Feature} */
  public readonly scenariosFeature = ngCore.inject(
    state.routeBound.scenarios.Feature,
  )

  /** @see {@link state.me.Feature} */
  public readonly meFeature = ngCore.inject(state.me.Feature)

  /**
   * {@link ents.core.admin.Scenario} that this {@link Component} represents.
   *
   * Route-bound scenario dropdown state can receive scenarios either from the
   * root `me` snapshot or from its own lightweight refresh query. The dropdown
   * only needs scenario data here, not user-access metadata.
   */
  public readonly scenarioSg = ngCore.input.required<ents.core.admin.Scenario>({
    alias: 'scenario',
  })

  /** TODO:  */
  public readonly isCurrentScenarioSg = ngCore.computed(
    (
      scenario = this.scenarioSg(),
      currentScenarioId = this.scenariosFeature.selectors.currentScenarioId.asSignal(),
    ) => scenario.id === currentScenarioId,
  )

  /** Indicates this scenario is being hovered over. */
  public readonly hoveringSg = ngCore.signal(false)

  /** Indicates this scenario's overflow menu should be shown. */
  public readonly showOverflowSg = ngCore.signal(false)

  /** Whether the current user can edit this scenario. */
  public readonly canEditScenarioSg = ngCore.computed(
    (scenario = this.scenarioSg()) =>
      this.meFeature.contexts.selectors.canEditScenario(scenario).asSignal(),
  )

  /** Whether the current user can delete this scenario. */
  public readonly canDeleteScenarioSg = ngCore.computed(
    (scenario = this.scenarioSg()) =>
      this.meFeature.contexts.selectors.canDeleteScenario(scenario).asSignal(),
  )

  /** Visibility sections the scenario can be moved into. */
  public readonly otherSectionsSg = ngCore.computed(
    (scenario = this.scenarioSg()) =>
      this.scenariosFeature.selectors
        .getOtherSectionsForScenario(scenario)
        .asSignal(),
  )

  /** Closes the dropdown after selecting a scenario route. */
  public scenarioClickHandler() {
    const scenario = this.scenarioSg()

    this.scenariosFeature.actions.closeOverlay
      .from(
        `ScenarioOverlay.Section-${scenario.visibility}.Scenario-${scenario.id}.Clicked`,
      )
      .dispatch()
  }

  /** Opens the route-bound scenario edit dialog. */
  public scenarioUpdateBtnClickedHandler() {
    if (!this.canEditScenarioSg()) {
      return
    }

    const scenario = this.scenarioSg()

    this.scenariosFeature.actions.openEdit
      .from(
        `ScenarioOverlay.Section-${scenario.visibility}.Scenario-${scenario.id}.Edit.Clicked`,
      )
      .dispatch({ scenario })
  }

  /** Opens the route-bound scenario delete confirmation. */
  public scenarioDeleteBtnClickedHandler() {
    if (!this.canDeleteScenarioSg()) {
      return
    }

    const scenario = this.scenarioSg()

    this.scenariosFeature.actions.openDelete
      .from(
        `ScenarioOverlay.Section-${scenario.visibility}.Scenario-${scenario.id}.Delete.Clicked`,
      )
      .dispatch({ scenario })
  }

  /** Moves a scenario into another visibility section. */
  public onOtherSectionClickHandler(
    section: state.routeBound.scenarios.models.Section,
  ) {
    if (!this.canEditScenarioSg()) {
      return
    }

    const scenario = this.scenarioSg()

    this.scenariosFeature.actions.moveToVisibility
      .from(
        `ScenarioOverlay.Section-${scenario.visibility}.Scenario-${scenario.id}.Options.OtherSection-${section.id}.Clicked`,
      )
      .dispatch({
        scenarioId: scenario.id,
        visibility: section.id,
      })
  }
}
